import { combineReducers } from "@reduxjs/toolkit";
import { appReducer as appStateReducer } from "modules/app";
import { authReducer } from "modules/auth";
import { facilityOptionsReducer } from "modules/facility-options";
import { memberReducer } from "modules/member";
import { messageReducer } from "modules/message";

const appReducer = combineReducers({
  app: appStateReducer,
  auth: authReducer,
  facilityOptions: facilityOptionsReducer,
  member: memberReducer,
  message: messageReducer,
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/logoutDone") state = undefined;
  return appReducer(state, action);
};

export default rootReducer;
